// extracted by mini-css-extract-plugin
export default {"copyCode":"abtasty-qa-assistant__CopyCode-module__copyCode___aE139"};